import { useEffect } from 'react';
import { useLingui } from '@lingui/react';

/**
 *
 * @param {Object} options
 * @param {Object} options.i18n - The i18n instance from Lingui.
 * @param {string} options.locale - The locale to load dictionaries for.
 * @param {Array<Function>} options.dictionaryLoaders - An array of functions that accept a locale (string) and return a Promise resolving to an object with a "messages" property.
 * @returns {Promise<void>} - A promise that resolves when all dictionaries have been loaded.
 */
export const loadDictionaries = ({
  i18n,
  locale,
  dictionaryLoaders
}) => {
  return Promise.all(dictionaryLoaders.map(loadDictionary => loadDictionary(locale).catch(error => {
    console.error(new Error(`Failed to load dictionary for locale "${locale}"`, {
      cause: error
    }));
    return {
      messages: {}
    };
  }))).then(modules => {
    modules.forEach(mod => {
      i18n.load(locale, mod.messages);
    });
  });
};

/**
 * This component uses the Lingui i18n library to load language dictionaries when the locale changes.
 *
 * @param {Object} props - The component's props.
 * @param {React.ReactNode} props.children - The child elements to be rendered.
 * @param {Array<Function>} [props.dictionaryLoaders] - An array of functions that accept a locale (string) and return a Promise resolving to an object with a "messages" property.
 */
const DictionariesLoader = ({
  children,
  dictionaryLoaders = []
}) => {
  const {
    i18n
  } = useLingui();
  const {
    locale
  } = i18n;
  useEffect(() => {
    loadDictionaries({
      i18n,
      locale,
      dictionaryLoaders
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
  return children;
};
export default DictionariesLoader;
//# sourceMappingURL=DictionariesLoader.js.map